const MIN_RUNES = 16

const TEMPLATE_TOKENS = [
  '【logline】',
  '【主题】',
  '【人物】',
  '【主线】',
  '【暗线】',
  '【世界观】',
  '【第一季】',
  '【第二季】',
  '【人物弧光】',
  '一句话故事',
  '谁要什么',
  '付出什么代价',
  '从哪里到哪里',
  '中途如何翻盘',
  '【开端】',
  '【发展】',
  '【高潮】',
  '【结局】',
  'logline',
  '主线',
  '钩子',
  '冲突',
  '反转',
  '悬念',
  '主角发现匿名信',
  '队友隐瞒真相',
  '信来自未来自己',
  '门外敲门声',
  '这里 context 填写本集剧情梗概',
  'agent 将利用该信息与上集梗概和上一场正文上下文',
  'fill in the episode summary here',
]

function stripExamplePrefix(raw: string): string {
  const text = raw.trim()
  for (const prefix of ['例：', '例:', 'e.g.', 'eg.', 'example:']) {
    if (text.toLowerCase().startsWith(prefix.toLowerCase())) {
      return text.slice(prefix.length).trim()
    }
  }
  return text
}

/** 全剧大纲 / 故事 / 本集梗概是否有真实正文（占位模板不算）。 */
export function hasWriterLayerContent(raw: string | null | undefined): boolean {
  if (!raw?.trim()) return false
  let text = stripExamplePrefix(raw).toLowerCase()
  for (const token of TEMPLATE_TOKENS) {
    text = text.split(token.toLowerCase()).join(' ')
  }
  const letters = [...text].filter((ch) => /[\p{L}\p{Script=Han}]/u.test(ch)).join('')
  return [...letters].length >= MIN_RUNES
}
